// Import React and other required libraries
import React from 'react';
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaFileInvoiceDollar, FaBuilding, FaRegCalendarAlt, FaClipboardList } from 'react-icons/fa';

const ClientData = ({ data }) => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Client Information</h1>
      
      <div style={styles.section}>
        <h2 style={styles.subheading}><FaBuilding /> Client Details</h2>
        <div style={styles.card}>
          <p><FaUser style={styles.icon} /> <strong>Name:</strong> {data.client_name}</p>
          <p><FaClipboardList style={styles.icon} /> <strong>Slug:</strong> {data.client_slug}</p>
          <p><FaEnvelope style={styles.icon} /> <strong>Primary Email:</strong> {data.client_primary_email}</p>
          <p><FaPhone style={styles.icon} /> <strong>Primary Phone:</strong> +{data.client_phone_code} {data.client_primary_phone}</p>
        </div>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subheading}><FaMapMarkerAlt /> Address</h2>
        <div style={styles.card}>
          <p><strong>City:</strong> {data.client_address.client_city || 'N/A'}</p>
          <p><strong>State:</strong> {data.client_address.client_state}</p>
          <p><strong>Country:</strong> {data.client_address.client_country} ({data.client_address.client_country_code})</p>
          <p><FaMapMarkerAlt style={styles.icon} /> <strong>Full Address:</strong> {data.client_address.client_full_address}</p>
        </div>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subheading}><FaUser /> Contact Person</h2>
        {data.contact_person.map((person, index) => (
          <div key={index} style={styles.card}>
            <p><FaUser style={styles.icon} /> <strong>Name:</strong> {person.contact_person_name}</p>
            <p><FaEnvelope style={styles.icon} /> <strong>Email:</strong> {person.contact_person_email}</p>
            <p><FaPhone style={styles.icon} /> <strong>Phone:</strong> {person.contact_person_phone}</p>
            <p><FaClipboardList style={styles.icon} /> <strong>Designation:</strong> {person.contact_person_designation}</p>
          </div>
        ))}
      </div>

      <div style={styles.section}>
        <h2 style={styles.subheading}><FaFileInvoiceDollar /> Quotations</h2>
        {data.quotations.map((quote, index) => (
         <div key={index} style={styles.card}>
         <p><strong>Quotation Amount:</strong> ₹{quote.quotation_amt}</p>
         <p><strong>Quotation ID:</strong> {quote.quotation_id}</p>
         <p><FaRegCalendarAlt style={styles.icon} /> <strong>Date:</strong> {new Date(quote.quotation_date).toLocaleDateString()}</p>
         <p><strong>Product Type:</strong> {quote.product_type}</p>
         <p><strong>Employee Name:</strong> {quote.employee_name}</p>
         <p><strong>Status:</strong> {quote.current_status}</p>
       
         <h3 style={styles.subSubheading}>Components</h3>
         <div style={styles.tableWrapper}>
           <table style={styles.table}>
             <thead>
               <tr>
                 <th style={styles.tableHeaderCell}>Item Name</th>
                 <th style={styles.tableHeaderCell}>Unit Price</th>
                 <th style={styles.tableHeaderCell}>Quantity</th>
                 <th style={styles.tableHeaderCell}>Total Price</th>
               </tr>
             </thead>
             <tbody>
               {quote.components.map((component, compIndex) => (
                 <tr
                   key={compIndex}
                   style={compIndex % 2 === 0 ? styles.tableRow : styles.tableRowAlt}
                 >
                   <td style={styles.tableCell}>{component.item_name}</td>
                   <td style={styles.tableCell}>₹{component.item_unit_price}</td>
                   <td style={styles.tableCell}>{component.item_quantity}</td>
                   <td style={styles.tableCell}>₹{component.item_total_price}</td>
                 </tr>
               ))}
             </tbody>
           </table>
         </div>
       </div>
        ))}
      </div>

      <div style={styles.section}>
        <h2 style={styles.subheading}><FaUser /> Created By</h2>
        <div style={styles.card}>
          <p><FaUser style={styles.icon} /> <strong>Employee Name:</strong> {data.created_by.employee_name}</p>
          <p><FaClipboardList style={styles.icon} /> <strong>Employee ID:</strong> {data.created_by.employee_id}</p>
        </div>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subheading}><FaClipboardList /> Employee Updates</h2>
        {data.employee_updates.map((update, index) => (
          <div key={index} style={styles.card}>
            <p><FaUser style={styles.icon} /> <strong>Employee Name:</strong> {update.epmloyee_name}</p>
            <p><FaClipboardList style={styles.icon} /> <strong>Employee ID:</strong> {update.epmloyee_id}</p>
            <p><FaRegCalendarAlt style={styles.icon} /> <strong>Date:</strong> {new Date(update.date).toLocaleDateString()}</p>
            <p><strong>Comment:</strong> {update.comment}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    lineHeight: '1.6',
    color: '#333',
    // maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    textAlign: 'center',
    color: '#4CAF50',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  subheading: {
    color: '#333',
    marginBottom: '10px',
    borderBottom: '2px solid #4CAF50',
    display: 'inline-block',
    paddingBottom: '5px',
  },
  subSubheading: {
    color: '#555',
    marginTop: '10px',
    fontWeight: 'bold',
  },
  section: {
    marginBottom: '30px',
  },
  card: {
    border: '1px solid #ddd',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '15px',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
  },
  componentCard: {
    border: '1px solid #e0e0e0',
    padding: '10px',
    borderRadius: '5px',
    background: '#fafafa',
    marginTop: '10px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
  },
//   table: {
//     width: '100%',
//     borderCollapse: 'collapse',
//     marginTop: '10px',
//   },
  'table th, table td': {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  },
  'table th': {
    backgroundColor: '#f2f2f2',
    fontWeight: 'bold',
  },
  icon: {
    marginRight: '8px',
    color: '#4CAF50',
  },
   // Other styles remain the same
   table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  },
  tableHeader: {
    backgroundColor: '#4CAF50',
    color: '#fff',
    textAlign: 'left',
  },
  tableRow: {
    backgroundColor: '#f9f9f9',
  },
  tableRowAlt: {
    backgroundColor: '#fff',
  },
  tableCell: {
    padding: '10px',
    border: '1px solid #ddd',
  },
  tableCellHover: {
    cursor: 'pointer',
    backgroundColor: '#f1f1f1',
  },
  tableHeaderCell: {
    padding: '10px',
    fontWeight: 'bold',
    borderBottom: '2px solid #ddd',
  },
  tableBody: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableWrapper: {
    marginTop: '15px',
    overflowX: 'auto',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
};


export default ClientData;

// Usage
// Import this component and pass the JSON data as a prop.
// Example:
// <ClientData data={yourData} />
